import AirplayPlugin from "@silvermine/videojs-airplay/src/js/index"
import "./airplay.scss"

export default AirplayPlugin;
